export const AccessControl = ({
  className,
  strokeColor = '#fff',
}: {
  className?: string
  strokeColor?: string
}) => {
  return (
    <svg
      className={className}
      height='48'
      viewBox='0 0 48 48'
      width='48'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <path d='M0 0h48v48H0V0z' fill='none' />
        <path
          d='M14.02816901 41.03225806V5.73352034l16-3.73352034v43l-16-3.96774194z'
          fill='none'
          stroke={strokeColor}
          strokeLinecap='butt'
          strokeLinejoin='round'
          strokeWidth='3'
        />
        <path
          d='M23 24.17741935v1'
          fill='none'
          stroke={strokeColor}
          strokeLinecap='round'
          strokeLinejoin='miter'
          strokeWidth='3'
        />
        <path
          d='M7 40.80645161V6.4'
          fill='none'
          stroke={strokeColor}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='3'
        />
        <path
          d='M41.3943662 40.80645161V6.4H37'
          fill='none'
          stroke={strokeColor}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='3'
        />
      </g>
    </svg>
  )
}
